import { useOne, useCustom } from '@refinedev/core';
import { USER_ONE_QUERY, USER_BY_AUTH_ID_QUERY } from '../pages/users/queries';
import { Typography, Skeleton } from 'antd';

const { Text } = Typography;

interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean;
  teamId?: string;
  organizationalRole?: string;
}

interface UserInfoProps {
  userId: string;
}

export const UserInfo = ({ userId }: UserInfoProps) => {
  const { data: byIdData } = useOne({
    resource: 'users',
    id: userId,
    queryOptions: { enabled: !!userId },
    meta: { gqlQuery: USER_ONE_QUERY },
  });

  const { data: byAuthIdData } = useCustom({
    url: '',
    method: 'get',
    meta: {
      gqlQuery: USER_BY_AUTH_ID_QUERY,
      gqlVariables: { authId: userId },
    },
    queryOptions: { enabled: !!userId },
  });

  const user = byIdData?.data?.user || byIdData?.data || byAuthIdData?.data?.userByAuthId;

  if (!user) {
    return <Skeleton.Input active style={{ width: 200 }} size="small" />;
  }

  const fullName = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(' ');

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Text strong>{fullName || user.email}</Text>
      {fullName && (
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {user.email}
        </Text>
      )}
    </div>
  );
};
